/**
 * Search customisation.
 */
export default class Search {
	constructor() {
		var languages = document.querySelector( '.search-languages' );
		var form = document.getElementById( 'searchform' );
		var submitButton = document.getElementById( 'searchsubmit' );
		if ( ! languages || ! form ) {
			return;
		}
		languages.addEventListener( 'change', () => {
			submitButton.click();
		} );
	}
};
